import apiRequest from './requestBase';

async function getFollowUserRequest(linkPath: string) {
  return apiRequest({
    method: 'GET',
    url: linkPath
  });
}

export default getFollowUserRequest;
